import clsx from 'clsx'
import './Spinner.css'

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export function Spinner({ size = 'md', className }: SpinnerProps) {
  return (
    <div className={clsx('spinner', `spinner--${size}`, className)}>
      <div className="spinner-ring" />
    </div>
  )
}

export default Spinner
